/**
 * @generated SignedSource<<a16366b90f5a72c0ad5ff91085b9f7f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProcedureFlags = "BOOKING_CROSS_SELL" | "COMBO" | "DISABLE_PRICE_MODIFIERS" | "FEATURED" | "FEMALE" | "LIPO_ADDON" | "LOCAL_ANESTHESIA_ELIGIBLE" | "MALE" | "MASSIVE_WEIGHT_LOSS" | "NON_SURGICAL" | "SPECIAL" | "TRANS" | "%future added value";
export type SpecialBadgeColor = "GOLD" | "GREEN" | "RED" | "%future added value";
export type QuoteProviderQuery$variables = {};
export type QuoteProviderQuery$data = {
  readonly businessLocations: ReadonlyArray<{
    readonly id: string;
    readonly image: string;
    readonly name: string;
  } | null> | null;
  readonly procedureTypes: ReadonlyArray<{
    readonly id: string;
    readonly image: string | null;
    readonly isInternal: boolean | null;
    readonly name: string;
    readonly position: number | null;
    readonly useForSimplifiedFlow: boolean | null;
  } | null> | null;
  readonly procedures: ReadonlyArray<{
    readonly activeEndsAt: any | null;
    readonly activeStartsAt: any | null;
    readonly beforeAfterImages: ReadonlyArray<string | null> | null;
    readonly description: string | null;
    readonly facts: ReadonlyArray<{
      readonly label: string;
      readonly labelEs: string | null;
      readonly value: string;
      readonly valueEs: string | null;
    } | null> | null;
    readonly flags: ReadonlyArray<ProcedureFlags> | null;
    readonly heroImage: string | null;
    readonly id: string;
    readonly image: string | null;
    readonly incompatibleProcedures: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly isInternal: boolean | null;
    readonly maleImage: string | null;
    readonly marketingName: string | null;
    readonly marketingNameEs: string | null;
    readonly name: string;
    readonly popularity: {
      readonly count: number | null;
      readonly tier: number | null;
    } | null;
    readonly position: number | null;
    readonly price: number | null;
    readonly prices: ReadonlyArray<{
      readonly id: string;
      readonly price: number | null;
      readonly surgeon: {
        readonly id: string;
        readonly name: string;
      } | null;
    }> | null;
    readonly procedureSlug: string;
    readonly procedureTypes: ReadonlyArray<{
      readonly id: string;
      readonly image: string | null;
      readonly name: string;
      readonly useForSimplifiedFlow: boolean | null;
    }> | null;
    readonly specialBadgeColor: SpecialBadgeColor | null;
    readonly specialBadgeText: string | null;
    readonly specialBadgeTextEs: string | null;
    readonly specialOfProcedureId: string | null;
    readonly subtitle: string | null;
    readonly subtitleEs: string | null;
    readonly tagline: string | null;
    readonly taglineEs: string | null;
  } | null> | null;
  readonly surgeons: ReadonlyArray<{
    readonly basePrice: number | null;
    readonly businessLocations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly daysUntilAvailable: number | null;
    readonly id: string;
    readonly image: string;
    readonly name: string;
    readonly nickname: string | null;
  } | null> | null;
};
export type QuoteProviderQuery = {
  response: QuoteProviderQuery$data;
  variables: QuoteProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useForSimplifiedFlow",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Surgeon",
    "kind": "LinkedField",
    "name": "surgeons",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "basePrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "daysUntilAvailable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BusinessLocation",
        "kind": "LinkedField",
        "name": "businessLocations",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "includeShadowed",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "isDiscontinued",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "isInternal",
        "value": false
      }
    ],
    "concreteType": "Procedure",
    "kind": "LinkedField",
    "name": "procedures",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingNameEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maleImage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flags",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "procedureSlug",
        "storageKey": null
      },
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeStartsAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeEndsAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeTextEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialOfProcedureId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Procedure",
        "kind": "LinkedField",
        "name": "incompatibleProcedures",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurgeonProcedure",
        "kind": "LinkedField",
        "name": "prices",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Surgeon",
            "kind": "LinkedField",
            "name": "surgeon",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedureType",
        "kind": "LinkedField",
        "name": "procedureTypes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tagline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taglineEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitleEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedureFact",
        "kind": "LinkedField",
        "name": "facts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelEs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueEs",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "beforeAfterImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroImage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedurePopularity",
        "kind": "LinkedField",
        "name": "popularity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "procedures(includeShadowed:true,isDiscontinued:false,isInternal:false)"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProcedureType",
    "kind": "LinkedField",
    "name": "procedureTypes",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BusinessLocation",
    "kind": "LinkedField",
    "name": "businessLocations",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QuoteProviderQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "abdea571a2239611995e7f04b5cc2e78",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderQuery",
    "operationKind": "query",
    "text": "query QuoteProviderQuery {\n  surgeons {\n    id\n    name\n    image\n    basePrice\n    daysUntilAvailable\n    nickname\n    businessLocations {\n      id\n      name\n    }\n  }\n  procedures(isInternal: false, isDiscontinued: false, includeShadowed: true) {\n    id\n    name\n    marketingName\n    marketingNameEs\n    description\n    image\n    maleImage\n    flags\n    isInternal\n    procedureSlug\n    price\n    position\n    activeStartsAt\n    activeEndsAt\n    specialBadgeText\n    specialBadgeTextEs\n    specialBadgeColor\n    specialOfProcedureId\n    incompatibleProcedures {\n      id\n      name\n    }\n    prices {\n      id\n      price\n      surgeon {\n        id\n        name\n      }\n    }\n    procedureTypes {\n      id\n      name\n      image\n      useForSimplifiedFlow\n    }\n    tagline\n    taglineEs\n    subtitle\n    subtitleEs\n    facts {\n      label\n      labelEs\n      value\n      valueEs\n    }\n    beforeAfterImages\n    heroImage\n    popularity {\n      tier\n      count\n    }\n  }\n  procedureTypes {\n    id\n    name\n    image\n    isInternal\n    useForSimplifiedFlow\n    position\n  }\n  businessLocations {\n    id\n    name\n    image\n  }\n}\n"
  }
};
})();

(node as any).hash = "04b3dc5fb888861aded5b32db7c0d611";

export default node;
